import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

export default function PieChart(props) {
  const {
    percentage,
    size,
    type
  } = props;

  const getProgressColor = (value) => {
    if (value === 0) {
      return type === 'containment' ? 'rgb(220, 37, 37)' : 'rgb(66, 183, 66)';
    }

    switch (type) {
      case 'containment':
        if (value <= 40) return 'rgb(220, 37, 37)'; 
        if (value >= 41 && value <= 80) return 'rgb(255, 208, 0)'; 
        return 'rgb(66, 183, 66)'; 
      case 'risk':
        if (value <= 10) return 'rgb(66, 183, 66)';
        if (value <= 49) return 'rgb(255, 251, 39)'; 
        return 'rgb(220, 37, 37)'; 
      default:
        return 'rgb(200, 200, 200)';
    }
  };

  const getFontSize = (size) => {
    if (size === 100 || size === 90) {
      return {
        value: '1.3rem',
        notAvailable: '0.8rem'
      }
    } else {
      return {
        value: '1.1rem',
        notAvailable: '0.75rem'
      }
    }
  }

  const hasValidPercentage = percentage !== null && percentage !== undefined;

  const progressValue = hasValidPercentage ? (percentage === 0 ? 100 : percentage) : 0;
  const progressColor = hasValidPercentage
    ? getProgressColor(percentage)
    : 'rgb(200, 200, 200)';

  return (
    <Box
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={size}
      height={size}
    >
      {/* Background circle (gray for remaining progress) */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={2}
        sx={{
          color: 'rgb(200, 200, 200)',
          position: 'absolute',
        }}
      />
      {/* Foreground circle (colored for progress) */}
      {hasValidPercentage && (
        <CircularProgress
          variant="determinate"
          value={progressValue}
          size={size}
          thickness={2}
          sx={{
            color: progressColor,
            position: 'absolute',
          }}
        />
      )}
      {/* Center text */}
      {hasValidPercentage ? (
        <Typography
          variant="h5"
          component="div"
          color="black"
          sx={{
            fontWeight: 'bold',
            fontSize: getFontSize(size).value,
          }}
        >
          {`${percentage}%`}
        </Typography>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ color: 'black', fontSize:  getFontSize(size).notAvailable,  }}>Not</div>
          <div style={{ color: 'black', fontSize:  getFontSize(size).notAvailable  }}>Available</div>
        </div>
      )}
    </Box>
  );
}
